import { render, staticRenderFns } from "./EmailBadge.vue?vue&type=template&id=28080d1d"
import script from "./EmailBadge.vue?vue&type=script&lang=ts"
export * from "./EmailBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports